import { render, staticRenderFns } from "./VoucherPremio.vue?vue&type=template&id=7eb27e20"
import script from "./VoucherPremio.vue?vue&type=script&lang=js"
export * from "./VoucherPremio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports